import Published2026 from "../../molecules/Published/2026";
import Published2022 from "../../molecules/Published/2022";
import Published2021 from "../../molecules/Published/2021";
import Published2020 from "../../molecules/Published/2020";

function Published() {
    return (
      <>
        <div>
          <Published2026/>
          <Published2022/>
          <Published2021/>
          <Published2020/>
        </div>
      </>
    );
  }
  
  export default Published;